export default __webpack_public_path__ + "static/media/m.61cacf8b.png";